<template>
	<section :id="['container-' + index + '-' + locationData.type]" :class="['container-' + locationData.type]">
		<div class="container-fluid">
			<MapComponent v-if="locationData.config.map.type == 'OpenStreetMap'" :mapId="['container-' + index + '-' + locationData.type]" :latitude="locationData.config.map.coordinates.latitude" :longitude="locationData.config.map.coordinates.longitude" :showAddress="locationData.config.showAddress" :type="locationData.config.map.type" />
			
			<MapComponent v-else-if="locationData.config.map.type == 'FileMap'" :mapId="['container-' + index + '-' + locationData.type]" :showAddress="locationData.config.showAddress" :type="locationData.config.map.type" :path="locationData.config.map.path" />
		</div>
		
		<div class="container-xl">
			<div class="row">
				<div class="col-12">
					<h2 v-if="locationData.config.title">{{ locationData.config.title }}</h2>
					<span class="freetext" :class="{'not-multiblock': isMultiblock == 'false'}" v-html="locationData.config.areaDescription"></span>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import MapComponent from "../MapComponent.vue";

export default {
	props: {
		locationData: {
			type: Object,
		},
		index: {
			type: Number
		},
		isMultiblock: {
			type: String
		}
	},

	components: {
		MapComponent
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-aachen/locationComponent.scss";
</style>